// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"rWNlkD","container":"nh2nrC"};